import { indexOf, intersection, size } from 'lodash'
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const tAuth = namespace('tAuth')
@Component
export default class RoleMixin extends Vue {
  @tAuth.Getter('getRole') rolesMixin!: string[]

  get fakeRole() {
    const result = []
    if (indexOf(this.rolesMixin, 'COURSE_ADMIN') !== -1) {
      result.push('COURSE_TEACHER')
    }
    return [...this.rolesMixin, ...result]
  }

  checkRole(role: string[]) {
    return size(intersection(this.fakeRole, role)) > 0
  }
}
